import router from "./index";

export default [
  {
    path: "/news",
    component: () => import('../views/News/News'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") != "admin")
        router.replace("/home");
      else
        next();
    },
    meta: {
      title: '新闻资讯'
    },
    children: [
      {
        path: '/',
        redirect: 'NewsList'
      },
      {
        path: 'NewsList',
        component: () => import('../views/News/NewsList/NewsList'),
        meta: {
          title: '新闻资讯列表'
        },
      },
      {
        path: 'AddNews',
        component: () => import('../views/News/AddNews/AddNews'),
        meta: {
          title: '添加新闻资讯'
        },
      },
    ]
  },
]
